export default __webpack_public_path__ + "static/media/half_checked.2c206d69.svg";